import devil from '../../../../assets/pixellab/diablito-smile-portrait.webp';

export default function StreakOverlay({ streakAnnouncer }) {
  if (!streakAnnouncer) return null;
  const { combo, multiplier } = streakAnnouncer;
  return (
    <div
      className="rhythm-announcement"
      key={combo}
      data-tier={multiplier}
      role="status"
      aria-label={`${combo} aciertos seguidos. Multiplicador ${multiplier}.`}
    >
      <span className="rhythm-combo-burst" aria-hidden="true" />
      <img src={devil} alt="" className="rhythm-combo-devil" draggable="false" />
      <div className="rhythm-combo-shout">
        <span>{multiplier >= 3 ? '¡INFERNAL!' : '¡BUENA RACHA!'}</span>
        <strong>×{multiplier}</strong>
        <small>{combo} aciertos seguidos</small>
      </div>
      <i className="rhythm-combo-spark spark-one" aria-hidden="true" />
      <i className="rhythm-combo-spark spark-two" aria-hidden="true" />
      <i className="rhythm-combo-spark spark-three" aria-hidden="true" />
    </div>
  );
}
